module.exports = __webpack_public_path__ + "img/multi_image01.3321266c.png";